import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VBuilderTemplate, HTMLInputEvent, Category, PageTemplate } from '../../shared/models/v-builder.models';
import { CommonHttpService } from '../../../shared/services/common-http/common-http.service';
import { MessageService } from '../../../shared/services/message/message.service';
import { CommunicationService } from 'src/app/shared/services/communication/communication.service';

@Component({
    selector: 'app-v-builder-category-template-modal',
    templateUrl: './v-builder-category-template-modal.component.html',
    styleUrls: ['./v-builder-category-template-modal.component.scss'],
    standalone: false
})
export class VBuilderCategoryTemplateModalComponent implements OnInit {

  validImgExt: string[] = ['jpg', 'jpeg', 'png'];
  uploadedImg: string | ArrayBuffer = '';
  verb: string;
  selectedGroups: any[];

  vBuilderTemplate: VBuilderTemplate;
  templateGroups = [];
  categoryId: number;
  pageTemplates: PageTemplate[] = [];
  shownTemplates: PageTemplate[] = [];

  constructor(
    private modalRef: BsModalRef,
    private commonHttpService: CommonHttpService,
    private messageService: MessageService,
    private communicationService: CommunicationService
  ) { }

  ngOnInit() {
    this.shownTemplates = this.pageTemplates;
    this.selectedGroups = ['All Groups'];
    this.filterTemplates();
    $('#templateGrp').attr('size', this.templateGroups.length);
  }

  /**
   * To set the template image in template list
   */
  setTemplateImgSrc(template: PageTemplate) {
    if (template.previewImageKey) {
      return `/api/Assets/Image/${template.previewImageKey}?width=120`;
    }
    return 'assets/img/NoImage.png';
  }

  /**
   * To set the image source for uploaded image for category custom icon
   */
  setImageSource() {
    if (this.uploadedImg) {
      return this.uploadedImg;
    } else if (this.vBuilderTemplate && this.vBuilderTemplate.pageIconAssetId) {
      return '/api/Assets/Image/' + this.vBuilderTemplate.pageIconAssetId;
    }
    return '';
  }

  /**
   * To handle uploaded image in category
   */
  imageSelected(event: HTMLInputEvent) {
    const selectedFile = event.target.files[0] as File;
    if (selectedFile) {
      const mimeType = selectedFile.type;
      if (mimeType.match(/image\/*/) != null && this.validImgExt.indexOf(mimeType.split('/').pop()) !== -1) {
        const formData = new FormData() as any;
        formData.append('file', selectedFile);
        this.commonHttpService.post(
          {
            uri: '/api/Assets/UploadImage',
            object: formData
          }).subscribe((response) => {
            const imgReader = new FileReader();
            imgReader.readAsDataURL(selectedFile);
            imgReader.onload = (e) => {
              this.uploadedImg = imgReader.result;
            };
            this.vBuilderTemplate.pageIconAssetId = response['id'] || 0;
          });
      } else {
        this.messageService.showWarningMessage('Image type must be jpeg/jpg or png');
      }
    }
  }

  /**
   * To filter the displayed template list based on selected template groups
   */
  filterTemplates() {
    const filteredTemp = [];
    if (this.selectedGroups.includes('All Groups')) {
      this.templateGroups.map(groups => {
        filteredTemp.push(...groups.pageTemplates)
      })
    } else {
      this.selectedGroups.filter(groupId => {
        const selectedGroup = this.templateGroups.find(group => group.id == groupId)
        if (selectedGroup) {
          filteredTemp.push(...selectedGroup.pageTemplates)
        }
      })
    }
    this.shownTemplates = filteredTemp;
  }

  /**
   * To save or update the playbook category
   */
  savePlaybookCategory() {
    this.vBuilderTemplate.vbuilderCatId = this.categoryId;
    if (this.vBuilderTemplate.id && this.verb === 'Edit') {
      this.commonHttpService.put<VBuilderTemplate, Category>(
        {
          uri: '/api/VBuilder/UpdateTemplate',
          object: this.vBuilderTemplate,
          message: {
            successMessage: 'Page template updated successfully.',
            errorMessage: 'Something went wrong while updating page template.'
          }
        }).subscribe((response: Category) => {
          this.communicationService.setPlabookSettingSubject({
            modalType: 'vbCategoryModal',
            type: 'update',
            value: response.vBuilderTemplates
          });
        });
    } else if (this.verb === 'Add') {
      this.commonHttpService.post<VBuilderTemplate, Category>(
        {
          uri: '/api/VBuilder/AddTemplate',
          object: this.vBuilderTemplate,
          message: {
            successMessage: 'Page template added successfully.',
            errorMessage: 'Something went wrong while adding page template.'
          }
        })
        .subscribe((response: Category) => {
          this.communicationService.setPlabookSettingSubject({
            modalType: 'vbCategoryModal',
            type: 'add',
            value: response.vBuilderTemplates
          });
        });
    }
    this.closeModal();
  }

  /**
   * To set the page template id
   */
  selectTemplate(template: PageTemplate) {
    this.vBuilderTemplate.pageTemplateId = template.id;
  }

  closeModal() {
    this.modalRef.hide();
  }

  openFileDialog() {
    $('#customPageIcon').trigger('click');
  }
}
